module.exports = __webpack_public_path__ + "img/documents.e49f62b1.svg";